"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.RPC_BASE = void 0;
const tslib_1 = require("tslib");
const uuid = require("uuid");
exports.RPC_BASE = { jsonrpc: '2.0' };
class ProviderRpcError extends Error {
    constructor(message, code, data) {
        super(message);
        this.code = code;
        this.data = data;
    }
}
function request(iframe, { method, params }, options = {}) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const requestId = uuid.v4();
        const req = {
            jsonrpc: '2.0',
            id: requestId,
            method,
            params,
            options,
        };
        console.debug('postmsg-rpc request', Object.assign({}, req));
        return new Promise((resolve, reject) => {
            const timeout = options.timeout &&
                setTimeout(() => {
                    window.removeEventListener('message', handleEvent);
                    reject(new ProviderRpcError('Request timed out', 408));
                }, options.timeout);
            const handleEvent = (event) => {
                if (event.data && event.data.id === requestId) {
                    console.debug(`resolve id: ${requestId}`, { event });
                    resolve(event.data);
                    window.removeEventListener('message', handleEvent);
                    timeout && clearTimeout(timeout);
                }
            };
            window.addEventListener('message', handleEvent);
            iframe.contentWindow.postMessage(req, '*');
        });
    });
}
exports.request = request;
